import type { EntradaRegistrada } from '@arena/shared/schemas';
import { dataValida } from '@arena/shared/tempo';
import { dinheiro } from '../agenda/formatos.js';

/**
 * Funções puras da compra a prazo na entrada de mercadoria — o que o modal
 * decide mostrar. Quem decide se a saída nasce prevista é o SERVIDOR, com o
 * dia da arena; aqui só se espelha a regra para avisar a pessoa antes e
 * confirmar depois.
 *
 * Ver: Arena_backend/Docs/plano/13-estoque-comandas.md
 */

/** As formas com que se paga um fornecedor, na ordem do select. */
export const FORMAS_DA_COMPRA = [
  { valor: 'Pix', rotulo: 'Pix' },
  { valor: 'Dinheiro', rotulo: 'Dinheiro' },
  { valor: 'Cartao', rotulo: 'Cartão' },
  { valor: 'Boleto', rotulo: 'Boleto' },
] as const;

/** `AAAA-MM-DD` válido? O `<input type="date">` entrega vazio enquanto incompleto. */
export function vencimentoValido(vencimento: string): boolean {
  return dataValida(vencimento);
}

/** O vencimento é um dia DEPOIS de hoje? Hoje e o passado são pagamento já feito. */
export function vencimentoNoFuturo(vencimento: string, hoje: string): boolean {
  return vencimentoValido(vencimento) && vencimento > hoje;
}

/** "10/07" — dia e mês de uma data `AAAA-MM-DD`. */
function diaEMes(data: string): string {
  return `${data.slice(8, 10)}/${data.slice(5, 7)}`;
}

/** O aviso sob o campo, só quando o vencimento é futuro. */
export function avisoDoVencimento(vencimento: string, hoje: string): string | undefined {
  return vencimentoNoFuturo(vencimento, hoje)
    ? 'A saída fica como prevista até você marcá-la como paga na tela do Financeiro.'
    : undefined;
}

/** `vencimento` só viaja quando é uma data inteira; campo vazio ou incompleto some. */
export function vencimentoParaEnviar(vencimento: string): { vencimento?: string } {
  return vencimentoValido(vencimento) ? { vencimento } : {};
}

/**
 * O toast depois de registrar. Fala pelo que o SERVIDOR respondeu
 * (`situacao`), não pelo que a tela supôs: se os dois discordarem sobre o dia
 * de hoje, vale o do servidor.
 */
export function textoDaEntradaRegistrada(
  resultado: Pick<EntradaRegistrada, 'custoTotal' | 'lancamentoId' | 'situacao'>,
  vencimento: string,
  cadastrados: string,
): string {
  if (resultado.situacao === 'Previsto' && vencimentoValido(vencimento)) {
    return `Compra registrada. Saída prevista de ${dinheiro(resultado.custoTotal)} para ${diaEMes(vencimento)}.${cadastrados}`;
  }
  return resultado.lancamentoId
    ? `Entrada registrada. Saída de ${dinheiro(resultado.custoTotal)} lançada em Fornecedores.${cadastrados}`
    : `Entrada registrada.${cadastrados}`;
}
